<template>
    <div class="declined-lenders" id="declinedLendersBlock" v-if="isDeclinedOrFraud || isLendindtree">
        <div v-if="hideLendingTree" class="mx-3 mx-sm-0">
            <h2 v-if="declinedLenderCount && !isLendindtree" class="mt-5">
                {{ $t('results.declinedLenders.declinedBy') }} <span class="count">{{ declinedLenderCount }}</span>
                {{ $tc('results.declinedLenders.lender', declinedLenderCount) }}
            </h2>

            <h2 v-else-if="isLendindtree && !isFraudDecline" class="mt-5">
                {{ $t('results.declinedLenders.lendindtreeDeclinedBy') }}
            </h2>

            <h2 v-else class="mt-5">
                {{ $t('results.declinedLenders.fraudDeclinedBy') }}
            </h2>
        </div>

        <div v-if="isDeclinedOrFraud && !isLendindtree" class="declined-description mx-3 mx-sm-0">
            {{
                copy && copy.rejected_description
                    ? copy.rejected_description
                    : $tc('results.declinedLenders.description', declinedLenderCount)
            }}
        </div>

        <div v-else-if="hideLendingTree" class="declined-description mx-3 mx-sm-0">
            {{
                hasNonAlternativeOffers === false
                    ? $t('results.declinedLenders.lendindtreeAlternativeDescription')
                    : $t('results.declinedLenders.lendindtreeDescription')
            }}
        </div>

        <DeclinedInfoBlock v-if="hideLendingTree" :copy="copy" />

        <div v-if="isDeclinedOrFraud && !isLendindtree" class="row gutter">
            <div class="col-12 col-md-6 col-lg-4" v-for="lender in declinedLenders" :key="lender.id">
                <DeclinedLenderBlock :lender="lender" />
            </div>
        </div>

        <slot name="offerListing"></slot>

        <div
            v-if="$te('results.declinedLenders.disclaimer')"
            class="result-disclaimer"
            v-html="$t('results.declinedLenders.disclaimer')"
        ></div>
    </div>
</template>

<script>
export default {
    props: ['declinedLenders', 'pageData', 'isFraudDecline', 'hasNonAlternativeOffers', 'status'],
    computed: {
        copy: function () {
            return this.pageData
        },
        declinedLenderCount: function () {
            if (this.isLendindtree && this.hasNonAlternativeOffers === true) {
                return null
            }

            return this.declinedLenders ? this.declinedLenders.length : null
        },
        isLendindtree: function () {
            return process.env.IS_LENDINDTREE
        },
        isDeclinedOrFraud: function () {
            return this.declinedLenderCount > 0 || this.isFraudDecline
        },
        hideLendingTree: function () {
            if (!this.isLendindtree) {
                return true
            }

            return (
                this.hasNonAlternativeOffers === false ||
                this.isFraudDecline ||
                (this.hasNonAlternativeOffers !== false && (this.declinedLenderCount || this.status === 'declined'))
            )
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.declined-lenders {
    h2 {
        font-family: var(--heading-font);
        font-size: rem(30px);
        font-weight: 600;
        line-height: rem(36px);
        @media screen and (max-width: $bp-small) {
            font-size: rem(20px);
        }
    }

    .result-disclaimer {
        color: #858585;
        font-size: rem(14px);
        margin-top: 40px;

        @media screen and (max-width: $bp-small) {
            margin: 12px;
            text-align: justify;
        }
    }
}

.gutter {
    @media screen and (max-width: $bp-small) {
        margin-left: 0;
        margin-right: 0;
    }
}
</style>
